import { blobServices } from "../../lib"
import { ApiError } from "../../utils";
import { setStreetViewMenu } from "./optionalMenuItems";

const getStreetPins = () => {
  return async (dispatch, getState) => {
    const fileName = 'ModelConfigrations.json';
    const jsonFile = await blobServices.download(fileName)
    .then((res) => {
      dispatch(setStreetViewMenu(true));
      return res.data
    })
    .catch((e) => {
      console.log(e);
      dispatch(setStreetViewMenu(false));
    });
    if (jsonFile) {
      dispatch({
        type: 'SET_STREET_PINS',
        data: jsonFile?.streetViewPins,
      });
       dispatch({
        type: 'SET_MODAL_CONFIGRATIONS',
        data: jsonFile,
      });
    } else {
      dispatch({
        type: 'SET_STREET_PINS',
        data: [],
      });
      dispatch({
        type: 'SET_MODAL_CONFIGRATIONS',
        data: {},
      });
    }
  }
}

const getEnvironment = () => {
  return async (dispatch, getState) => {
    const fileName = 'EnviornmentConfigrations.json';
    const jsonFile = await blobServices.download(fileName)
    .then((res) => {
      dispatch(setStreetViewMenu(true));
      return res.data
    })
    .catch((e) => {
      console.log(e);
      dispatch(setStreetViewMenu(false));
    });
    if (jsonFile) {
      dispatch({
        type: 'SET_ENVIRONMENT',
        data: jsonFile,
      });
    } else {
      dispatch({
        type: 'SET_ENVIRONMENT',
        data: {},
      });
    }
  }
}

const updateEnvironment = (data) => {
  return async (dispatch, getState) => {
    dispatch({
    type: 'SET_ENVIRONMENT',
    data: data,
    });
  }
}

export {
  getStreetPins,
  getEnvironment,
  updateEnvironment,
}